import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;

  table {
    width: 100%;
    table-layout: fixed;
  }

  /* OEM NAME */
  th:nth-child(1),
  td:nth-child(1) {
    width: 18rem;
  }

  /* WMI CODES — takes the remaining space and wraps content when expanded */
  th:nth-child(2),
  td:nth-child(2) {
    width: auto;
  }

  td:nth-child(2) > span {
    word-break: break-word;
  }

  /* ACTIONS */
  th:nth-child(3),
  td:nth-child(3) {
    width: 14rem;
  }
`;
export default TableWrapper;
